export default __webpack_public_path__ + "static/media/icon-delay-filled.3d69b9ba.svg";